import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function pow10(n) {
  return 10 ** n;
}

function formatDecimalForMath(value, digits) {
  const s = Number(value).toFixed(digits);
  return s.replace(/\.?0+$/, "");
}

function formatDecimalPl(value, digits) {
  return formatDecimalForMath(value, digits).replace(".", ",");
}

function pickData() {
  const p1 = randInt(1, 3);
  const p2 = randInt(1, 3);

  const aRaw = randInt(25, 950);
  const bRaw = randInt(12, 820);

  const op = Math.random() < 0.5 ? "+" : "-";
  const p = Math.max(p1, p2);

  let aUnits = aRaw * pow10(p - p1);
  let bUnits = bRaw * pow10(p - p2);

  if (op === "-" && aUnits < bUnits) {
    [aUnits, bUnits] = [bUnits, aUnits];
  }

  const resultUnits = op === "+" ? aUnits + bUnits : aUnits - bUnits;

  return {
    op,
    p,
    p1,
    p2,
    aUnits,
    bUnits,
    resultUnits,
    a: aUnits / pow10(p),
    b: bUnits / pow10(p),
    result: resultUnits / pow10(p),
  };
}

export function generateTask() {
  const data = pickData();
  return {
    type: "DecimalAddSubtractTask",
    data,
  };
}

export function renderTask({ data }) {
  const aLatex = formatDecimalForMath(data.a, data.p);
  const bLatex = formatDecimalForMath(data.b, data.p);

  return (
    <div style={{ textAlign: "left" }}>
      <p>Oblicz: <InlineMath math={`${aLatex} ${data.op} ${bLatex}`} /></p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="wynik"
      placeholder="np. 12,35 lub 12.35"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - task.data.result) < 1e-9;
}

export function renderAnswer({ data }) {
  const ans = formatDecimalForMath(data.result, data.p);
  return <InlineMath math={ans} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

export function renderExplanation({ data }) {
  const aPl = formatDecimalPl(data.a, data.p);
  const bPl = formatDecimalPl(data.b, data.p);
  const resultPl = formatDecimalPl(data.result, data.p);
  const aLatex = formatDecimalForMath(data.a, data.p);
  const bLatex = formatDecimalForMath(data.b, data.p);
  const rLatex = formatDecimalForMath(data.result, data.p);

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        <strong>Krok 1:</strong> Ustawiamy liczby tak, aby przecinki były jeden pod drugim:
      </p>
      <p>
        {aPl} {data.op} {bPl}
      </p>

      <p>
        <strong>Krok 2:</strong> Wykonujemy działanie cyframi:
      </p>
      <BlockMath math={`${aLatex} ${data.op} ${bLatex} = ${rLatex}`} />

      <p>
        <strong>Wynik:</strong> {resultPl}
      </p>
    </div>
  );
}


